import type { BoxProps } from '../Core';
import { Note } from './Note';
import { useNotes } from './NotesProvider';
import { Wrapper } from './styles';

export * from './NotesProvider';
export { Square, Squares } from './styles';
export { NoteVariant, type NoteProps } from './types';

export const Notes = (props: BoxProps) => {
  const { notes } = useNotes();
  return notes.length ? (
    <Wrapper {...props}>
      {notes.map(note => (
        <Note {...note} key={note.id} />
      ))}
    </Wrapper>
  ) : null;
};
